module.exports = __webpack_public_path__ + "static/media/lottery.50142590.jpg";